var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcn24X24View(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn_24x24_view"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.20801 1.6665C4.17426 1.6665 3.33301 2.50775 3.33301 3.5415V16.4582C3.33301 17.4919 4.17426 18.3332 5.20801 18.3332H13.7497V18.312C12.7534 18.2128 11.861 17.7603 11.196 17.0832H5.20801C4.86342 17.0832 4.58301 16.8028 4.58301 16.4582V3.5415C4.58301 3.19692 4.86342 2.9165 5.20801 2.9165H9.99967V6.45817C9.99967 7.49192 10.8409 8.33317 11.8747 8.33317H15.4163V10.1919C15.8726 10.3356 16.2926 10.5596 16.6663 10.8413V7.70817C16.6663 7.53546 16.5964 7.37935 16.4832 7.26628L11.0666 1.84961C10.9534 1.73654 10.7972 1.6665 10.6247 1.6665H5.20801ZM11.2497 3.80029L14.5326 7.08317H11.8747C11.5301 7.08317 11.2497 6.80275 11.2497 6.45817V3.80029ZM14.1663 10.8332C12.3284 10.8332 10.833 12.3286 10.833 14.1665C10.833 16.0044 12.3284 17.4998 14.1663 17.4998C14.8601 17.4998 15.5039 17.2862 16.0381 16.922L18.0994 18.9834C18.2215 19.1059 18.3813 19.1665 18.5413 19.1665C18.7013 19.1665 18.8612 19.1055 18.9832 18.9834C19.227 18.7392 19.227 18.3438 18.9832 18.0996L16.9227 16.0382C17.2864 15.5041 17.4997 14.8603 17.4997 14.1665C17.4997 12.3286 16.0043 10.8332 14.1663 10.8332ZM14.1663 12.0832C15.3151 12.0832 16.2497 13.0178 16.2497 14.1665C16.2497 15.3153 15.3151 16.2498 14.1663 16.2498C13.0176 16.2498 12.083 15.3153 12.083 14.1665C12.083 13.0178 13.0176 12.0832 14.1663 12.0832Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcn24X24View);
export default __webpack_public_path__ + "static/media/icn_24x24_view.8d97aee29607d80ea24d3f864896a95f.svg";
export { ForwardRef as ReactComponent };